import { 
  Stack, Paper, Typography, Grid, 
  Box,
  Chip
} from '@mui/material';
import { useEffect, useState } from 'react';
import CheckCircleOutlineIcon from '@mui/icons-material/CheckCircleOutline';

const PDFSupportAmount = 20;
const monthNames = ["January", "February", "March", "April", "May", "June", "July", "August", "September", "October", "November", "December"];

const getID = (frid, id) => {
  if (frid && id) {
    let fr_id = String(frid).padStart(3, '0'),
    member_id = String(id).padStart(7, '0');
    return 'PRF - ' + fr_id + ' - ' + member_id;     
  }
  else 
    return '-';
};

const getMonth = (date) => {
  if (date) {
      let month = new Date(date).getMonth(),
      year = new Date(date).getFullYear();
    return monthNames[month].substring(0,3) + ' - ' + year;
  }
  else
    return '-';
};

export function MemberCardInfo(props) {
  const [record, setRecord] = useState(null);
  const [showMember, setShowMember] = useState(false);

  useEffect(() => {
    if (props?.data) {
      parseData(props?.data);
    }
  },[props]);

  useEffect(() => {
    setShowMember(true);
  },[record]);

  const parseData = (data) => {
    let t = data.transactions;
    if (t && t.length > 0) {
      data.earliest = t.reduce((a, b) => (a.valid_thru < b.valid_thru ? a : b));
      data.latest = t.reduce((a, b) => (a.valid_thru > b.valid_thru ? a : b));
      data.months = t.length;
      data.total = t.reduce((a, v) => a = a + v.ofp_usd_est,0).toFixed(2);
      data.pdf = Math.ceil(data.total / PDFSupportAmount);  
    }
    setRecord(data);
  }

  const MemberInfo = () => {
    if (!record) {
      return (<></>);
    }
    
    let thisData = (props.memberid_flag) ?
    [
      {
        label: 'ထောက်ပို့တပ်သား',
        value: record.member_name
      },
      {
        label: 'ကိုယ်ပိုင်အမှတ်',
        value: getID(record.latest.fundraiser_id, record.member_id)
      },
      {
        label: 'စတင်ထောက်ပို့ခဲ့သည့်လ',
        value: getMonth(record.earliest.valid_thru)
      },
      {
        label: 'နောက်ဆုံးထောက်ပို့ခဲ့သည့်လ',
        value: getMonth(record.latest.valid_thru)
      },
      {
        label: 'နောက်ဆုံးထောက်ပို့ခဲ့သည့်လ၏ ငွေအမောင့်',
        value: 'EUSD ' + record.latest.ofp_usd_est
      }
    ] :
    [
      {
        label: 'ထောက်ပို့တပ်သား',
        value: record.member_name
      },
      {
        label: 'ကိုယ်ပိုင်အမှတ်',
        value: getID(record.latest.fundraiser_id, record.member_id)
      },
      {
        label: 'ထောက်ပို့သည့်လ',
        value: getMonth(record.latest.valid_thru)
      }
    ];

    return (
      <Paper
        sx={{
          height: "100%",
          borderRadius: "1.5rem",
          backgroundColor: "#fff",
        }}
        key={record.member_id + "memberinfo"}
      >
        <Typography
          sx={{
            color: "#fff",
            typography: {
              lg: "h5",
              md: "h6",
              sm: "subtitle1",
            },
            fontWeight: {
              md: "normal",
              sm: "bold",
            },
            padding: "1rem",
            background: "linear-gradient(to right, #B91C1C, #530D0D)",
            borderTopLeftRadius: "1.5rem",
            borderTopRightRadius: "1.5rem",
          }}
        >
          ပြည်သူ့တော်လှန်ရေးထောက်ပို့တပ်သားအချက်အလက်
        </Typography>
        
        <Box sx={{ 
          p: 3,
          display: 'flex',
          flexDirection: 'column',
          gap: 2
        }}>
          {thisData.map((item, index) => (
            <Box key={index} sx={{ 
              display: 'flex',
              alignItems: 'center',
              gap: 2
            }}>
              <Typography sx={{ 
                minWidth: '180px',
                color: '#000',
                fontSize: '16px',
                fontWeight: 'normal'
              }}>
                {item.label}
              </Typography>
              <Typography sx={{ 
                color: '#000',
                fontSize: '16px',
                fontWeight: 'bold'
              }}>
                {item.value}
              </Typography>
            </Box>
          ))}
        </Box>

        <Stack
          direction={"row"}
          sx={{
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            my: 2,
          }}
        >
          <Box
            sx={{
              backgroundColor: "#F6FFED",
              borderRadius: "16px",
              display: "inline-block",
              p: "8px",
              border: "2px solid #B7EB8F",
            }}
          >
            <Stack
              direction={"row"}
              spacing={1}
              sx={{
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
              }}
            >
              <CheckCircleOutlineIcon
                sx={{
                  fontSize: {
                    sm: "1.5rem",
                    xs: "1rem",
                  },
                  color: "#52C41A",
                }}
              />
              <Typography
                sx={{
                  color: "#52C41A",
                  fontSize: {
                    sm: "100%",
                    xs: "70%",
                  },
                }}
              >
                အချက်အလက်မှန်ကန်ကြောင်း အသိအမှတ်ပြုအပ်ပါသည်။
              </Typography>
            </Stack>
          </Box>
        </Stack>
      </Paper>
    );
  };

  return (
    <>
      {showMember && <MemberInfo />}
    </>
  );
}
